import * as React from 'react';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';

import connectToStores from 'js/lib/connectToStores';

import PageFooter from 'bundles/page-footer/components/PageFooter';
import PageHeader from 'bundles/page-header/components/PageHeader';
import ApplicationStoreClass from 'bundles/ssr/stores/ApplicationStore';

type Props = {
  children?: JSX.Element;
};

export class UnsubscribeApp extends React.Component<Props> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
    getStore: PropTypes.func.isRequired,
  };

  declare context: LegacyContextType<typeof UnsubscribeApp.contextTypes>;

  static childContextTypes = {
    csrfToken: PropTypes.string,
    requestCountryCode: PropTypes.string,
  };

  render() {
    const { children } = this.props;
    return (
      <div className="rc-UnsubscribeApp">
        <PageHeader />
        {children}
        <PageFooter />
      </div>
    );
  }
}

// TODO: connectToStores<Props, InputProps, Stores>
export default connectToStores([ApplicationStoreClass], (ApplicationStore, props) => ({
  ...props,
  csrfToken: ApplicationStore.getState().csrfToken,
  requestCountryCode: ApplicationStore.getState().requestCountryCode,
}))(UnsubscribeApp);
